module.exports = __webpack_public_path__ + "img/hr.8c72234f.png";